import { useState, useRef } from 'react';

function DropdownFilter({ title, placeholder, options, selectedValues, setSelectedValues, offsetTop }) {
  const [isInputFocused, setIsInputFocused] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const dropdownRef = useRef(null);

  const handleOptionClick = (opt) => {
    const alreadyExists = selectedValues.some(c => c.value === opt.value);
    if (!alreadyExists) {
      setSelectedValues(prev => [...prev, opt]);
    }
    setIsInputFocused(false);
    setSearchTerm('');
  };

  // Fechar dropdown apenas se o clique foi fora do componente
  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsInputFocused(false);
    }
  };

  // Adicionar event listener para clique fora
  useState(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className='unity-filter' ref={dropdownRef}>
      <p className='filter-subtitle'>{title}</p>

      <input
        className='input-filter'
        placeholder={placeholder}
        value={searchTerm}
        onFocus={() => setIsInputFocused(true)}
        onChange={(e) => setSearchTerm(e.target.value)}
        // Remover onBlur ou modificar
        onBlur={() => {
          // Pequeno delay para permitir o clique na opção
          setTimeout(() => setIsInputFocused(false), 150);
        }}
      />

      {isInputFocused && (
        <div className="dropdown-filterP" style={{ top: `${offsetTop}px` }}>
          {options
            .filter(opt =>
              opt.label.toLowerCase().includes(searchTerm.toLowerCase()) &&
              !selectedValues.some(selected => selected.value === opt.value)
            )
            .map((opt, index) => (
              <div
                key={index}
                className="dropdown-item"
                onMouseDown={(e) => e.preventDefault()} // Impede o blur
                onClick={() => handleOptionClick(opt)}
              >
                {opt.label}
              </div>
            ))}
        </div>
      )}

      {selectedValues.length > 0 && (
        <div className="selected-countries">
          {selectedValues.map((opt, index) => (
            <div key={index} className="country-chip">
              {opt.label}
              <img
                src="/imagens/x.svg"
                className="remove-chip"
                onClick={() =>
                  setSelectedValues(prev =>
                    prev.filter(c => c.value !== opt.value)
                  )
                }
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default DropdownFilter;